import React, {cloneElement, ReactNode, useContext, useEffect, useState} from "react";
import {useHistory} from "react-router";
import {Search} from "../../../filtering";
import {oceanImportHblList, TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import {NavigationType, openNewPage} from '../../../util/navigationHelpers';
import lockBlue from '../../../img/lock_blue.png';
import lockRed from '../../../img/lock_red.png';
import cntrBlack from '../../../img/container_tracking-black.svg';
import cntrWhite from '../../../img/container_tracking-white.svg';
import iManifestIcon_blue from '../../../img/iManifest-blue.svg';
import {
  DateRenderer,DateTimeRenderer,FloatRenderer,TextAlignLeftWithAddressTooltipRenderer,
  NullableCheckboxIconRenderer,TextAlignLeftRenderer,TextAlignRightRenderer,TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import Select from '../../../ui/Select';
import PrimaryButton from '../../../ui/PrimaryButton';
import {ActionButtonItem, borderColors, splitMenuItemsIntoSections} from '../../../ui/ActionButton';
import MoveTypeDropDown from '../../../uiControls/MoveTypeDropDown';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import UniqueLinkButton from '../../../uiControls/UniqueLinkButton';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import JobListViewContext, {IJobListViewContext, RightClickContext} from '../../common/JobListViewContext';
import ApplicationContext from "../../../ApplicationContext";
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import {formatHblType} from './implementation/hblUtils';
import {JobNames} from "../../../framework.core/JobNames";
import loadInfoAreaInvoiceBillCrDb from '../../../components/common/InfoAreaInvoiceBillCrDb';
import {OiHblListItem, OihListType} from '../../../fms.data/models/OiHblListItem';
import * as XCol from "../../../framework.core/XExportColumn";
import IfmsModal from "../../../ui/IfmsModal";
import Menu, {IfmsMenuItem} from "../../../ui/menu/Menu";
import ListViewShortcutMenu from "../../common/ListViewShortcutMenu";
import fastStorage from '../../../fastStorage';
import HblBlStatusPopup from "./HblBlStatusPopup";
import {ReactComponent as ContainerTrackingIcon} from "../../../img/container_tracking.svg";
import { FmsSubMenu } from "../../../constants/fmsSubMenu";
import { getSelectedSubMenuArgs } from '../../JobListSubMenu';
import useReportViewer from "../../../hooks/useReportViewer";
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { BillingsRenderer, BillInvoiceCrdbFilterRenderer, RecognizedFilterRenderer, RecognizedRenderer, ShipmentTypeFilterRenderer, 
  ShipmentTypeRenderer, TrackEventNameRenderer, RQFilterRenderer, 
  LastEventRenderer} from "../../common/commonListRenderers";
import DeleteHistory from "../../reports/DeleteHistory";
import postal from 'postal';
import { formatDate, formatDateTime, nowDate } from "../../../dateUtils";
import useSetEditedId from "../../../hooks/useSetEditedId";
import { FmsSecTask } from "../../../fms.core/constants";
import { getFmsGlobal } from "../../../globals";
import BlackInverseButton from '../../../ui/BlackInverseButton';
import _ from "lodash";
import TrackingRequest from "../../reports/TrackingRequest";
import { SuntekSettings, SystemSettings } from "../../../ifmsTypes";
import { findSecurityTask } from "../../../util";
import { useJournal } from "../../accounting/general/journal/JournalListView";
import useSuntekSettings from "../../../hooks/useSuntekSettings";
import useSystemSettings from "../../../hooks/useSystemSettings";
import HblReleasePopup from "./HblReleasePopup";
import CheckBoxIcon from "../../../ui/CheckBoxIcon";
import PrimaryInverseButton from "../../../ui/PrimaryInverseButton";
import { useAppDispatch } from "../../../app/hooks";
import RecogModal from "../../../ui/RecogModal";
import constants from "../../../constants";
import { Decimalformat, intAsCheckBoxValue, nullableCheckBoxValue } from "../../common/commonExportFormat";
import UseAMSISfIcon from '../../../img/Isf_P_circle.svg';

// function IndicatorRenderer({data, value, row}:any) {
//   const jobListContext = useContext(JobListViewContext);

//   function onIndicatorClick() {
//     if (jobListContext.rowExtrasId) {
//       return; // Some row is already selected
//     }

//     jobListContext.setRowExtrasId(data[row.index].id);
//   }

//   let content = <span></span>;

//   if (value === 'A') {
//     content = <span>A</span>;
//   }
//   if (value === 'C') {
//     content = <IconLock size={15} color="#D97706" />
//   }
//   if (value === 'P') {
//     content = <img height="15px" src={periodClosedIcon} alt="P. Closed" />;
//   } else {
//     content =  <span>D</span>;
//   }

//   return (
//     <div className="ifms-table-default" data-tooltip="B/L Status" style={{width: '100%',height: '100%', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center'}} onClick={onIndicatorClick}>{content}</div>
//   );
// }

// function RefNoRenderer({cell, data, row}: any) {
//   const jobListContext = useContext(JobListViewContext);
//   const history = useHistory();

//   function switchToMbl() {
//     jobListContext.setFilterForScreenExternally('/common/joblistview/mbl/oceanImport',
//       'id', '', data[row.index].oiMblId.toString(), 'update', false, true
//       );
//     openNewPage(history, `/common/joblistview/mbl/oceanImport`, NavigationType.newPage);
//   }

//   return (
//     <div onClick={switchToMbl} className="ifms-table-align-left" style={{color: 'blue', fontWeight: 'bold'}}>{cell.value}</div>
//   );
// }

function IndicatorRenderer({ data, row }: any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';
  else if (lStatus === 'OC') dataTooltip = 'OP Close';

  /*
  function onIndicatorClick() {
    if (jobListContext.rowExtrasId) {
      return; // Some row is already selected
    }

    jobListContext.setRowExtrasId(data[row.index].id);
  }
*/

  let content: React.ReactNode = <></>;
  //if ((l as any).isClosed) {
  if (lStatus === 'PC')
    content = <img height="7px" src={lockRed} id={'redIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;
  else if (lStatus === 'OC')
    content = <img height="7px" src={lockBlue} id={'blueIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;
  //}

  return (
    //<div className="ifms-table-default" data-tooltip="B/L Status" style={{width: '100%', minHeight: '22px', cursor: 'pointer'}} onClick={onIndicatorClick}>{content}</div>
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

 function OblDateRenderer({ row, cell }: any) {

  const {OblColClickFor} = useHblOperations();

   return <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} onClick={() => OblColClickFor('oblDate', row.original)}>
      {formatDate(cell.value)}&nbsp;
    </div>
}

function OblColRenderer({ row, cell }: any) {
  const {OblColClickFor} = useHblOperations();

  return <div  onClick={() => OblColClickFor('oblStat', row.original)} className="ifms-table-default">{cell.value}&nbsp;</div>;
}

function RlsDateRenderer({ row, cell }: any) {
  const {RlsColClickFor} = useHblOperations();

   return <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} onClick={() => RlsColClickFor(row, row.original)}>
      {formatDate(cell.value)}&nbsp;
    </div>
}

function RlsStatRenderer({ row, cell }: any) {
  const {RlsColClickFor} = useHblOperations();

  return <div onClick={() => RlsColClickFor(row, row.original)} className="ifms-table-default">{cell.value}&nbsp;</div>;
}

function HblTypeFilterRenderer({value, onChange}:any) {
  return (
    <Select
      name='ifms-filter-hblType-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { value: 'None', label: 'None'},
        { value: 'S', label: 'Standard'},
        { value: 'C', label: 'Co-Load'},
      ]}
    />
  );
}

function MoveTypeFilterRenderer({value, onChange}:any) {
  return (
    <MoveTypeDropDown
      name='ifms-filter-moveType-select'
      value={value}
      onChange={moveType => onChange(moveType)}
    />
  );
}

// function CheckboxFilterRenderer({value, onChange}:any) {
//   const boolValue = typeof value === 'boolean' ? value : !!value;
//   return  <CheckBox label='Search for Checked Box' value={boolValue} onChange={onChange} />
// }

function AmsRenderer({ cell, row, data }: any) {
  const l = data[row.index];
  const useAms = (l as any).useAms as boolean;

  if (useAms) {
    if (cell && cell.value) {
      return (
        <div className="ifms-table-align-left" id={`ifms-table-align-left-${row.index}`} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', minHeight: '22px' }}><img height="13px" src={UseAMSISfIcon} alt="" data-toolip = '123' /></div>
      );
    }
  } else {
    if (cell && cell.value) {
      return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-default">
        <CheckBoxIcon value={true} />
      </div>;  
    }
  }

  return <div className="ifms-table-align-center" id={`ifms-table-default-${row.index}`} >x</div>;
}

function IsfRenderer({ cell, row, data }: any) {
  const l = data[row.index];
  const useIsf = (l as any).useIsf as boolean;

  if (useIsf) {
    if (cell && cell.value) {
      return (
        <div className="ifms-table-align-left" id={`ifms-table-align-left-${row.index}`} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', minHeight: '22px' }}><img height="13px" src={UseAMSISfIcon} alt="" /></div>
      );
    }
  } else {
    if (cell && cell.value) {
      return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-default">
        <CheckBoxIcon value={true} />
      </div>;  
    }
  }

  return <div className="ifms-table-align-center" id={`ifms-table-default-${row.index}`} >x</div>;
}

function InbondRenderer({ cell, row, data }: any) {
  const l = data[row.index];

  if (!!l.itNo) {
    if (cell && cell.value) {
      return (
        <div className="ifms-table-align-left" id={`ifms-table-align-left-${row.index}`}>{l.itNo}</div>
      );
    }
  } else {
    if (cell && cell.value) {
      return <div className="ifms-table-align-center" id={`ifms-table-default-${row.index}`} >x</div>;
    }
  }
  return <div className="ifms-table-align-center" id={`ifms-table-default-${row.index}`} >x</div>;
}

// function ChbRenderer({value, data, row}: any) {
//   let content: React.ReactNode = <></>;
//   if (value)
//     content = <img height="14px" src={chbBlue} alt="" />;
//   else
//     content = <img height="14px" src={chbGray} alt="" />;

//   return (
//     <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', minHeight: '22px' }}>{content}</div>
//   );
// }

function ChbRenderer({ cell, row, data }:any) {
  const l = data[row.index];
  const tooltip = l.chbRspCode === 'x' ? undefined : `${l.chbRspCode} - ${l.chbRspMsg}`;
  return <div id={`${cell.column.id}-${row.index}`} className="ifms-table-default" data-tooltip={tooltip}>{cell.value}</div>;
}

function PaidRenderer({value, data, row}: any) {
  const {switchToAcctInfo} = useHblOperations();

  const isPaid = value !== 'x';

  if (!isPaid) {
    return <div className="ifms-table-default">{value}</div>;
  }

  return <PrimaryInverseButton onClick={() => switchToAcctInfo(data[row.index])} style={{width: '100%', lineHeight:'1em'}}>{value}</PrimaryInverseButton>
}

// function AfterMemoLogButtonCommands() {
//   const jobListContext = useContext(JobListViewContext);
//   const selectedElement = jobListContext.selectedElement as OiHblListItem;

//   return (
//     <>
//       &nbsp;&nbsp;
//       <BlackInverseButton size='small' data-tooltip="Go to Carrier's Tracking"
//         onClick={() => window.open(`http://dotnet.freightstream.com/fsutil/customs.asp?mbn=${selectedElement?.mblNo}`)}>
//         <img height="24px" width='24px' src={carriersTrackingIcon} alt="Go to Carrier's Tracking" style={{ position: 'relative', top: '-1px' }} />
//       </BlackInverseButton>
//     </>
//   )
// }

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as OiHblListItem;
  const {switchJournal} = useJournal();
  const suntekSettings = useSuntekSettings();
  
  if (!suntekSettings.general?.allowViewJournalOP && !userId.startsWith('@')) {
    return null;
  }

  return (
    <PrimaryButton
      size="regular"
      onClick={()=> switchJournal(JobNames.OIHbl, selectedElement.id)}>
      {constants.List_Journal}
    </PrimaryButton>
  );
}

function HblListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem|null>(null);
  
  const selectedElement = jobListContext.selectedElement as OiHblListItem;
  const setSavedEntityJournal = useSetEditedId([JobNames.SlipJournal]);

  const { deleteHbl, edit, view, copy, viewBillings, moveToDeleteHistoryReport, setSavedEntityOim } = useSelectedHblOperations();

  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const { viewReport } = useReportViewer();
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  
  const fmsGlobal = getFmsGlobal();

  function hasOpenedViewOrEditFor(id:number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/hbl/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/hbl/view/${id}`);
  }

  function doAfterRecog(){
    jobListContext.reloadData();
    setSavedEntityOim(selectedElement.oiMblId.toString(), false);
    setSavedEntityJournal('0', false, false, true);
  }

  const onRecogModalClose = () => {
    jobListContext.setRecogModalData({ isOpen: false, isSet: false });
  }

  function hasOpenedNew() {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/hbl/add`);
  }

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  const onLinkClick = (link: string) => {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }
    
    window.open(link);
  }

  async function onSubMenuClick(fmsSubMenu: FmsSubMenu) {
    setSelectedPopupMenuItem(null);

    if (!selectedElement) {
      return;
    }

    const args = await getSelectedSubMenuArgs(fmsSubMenu, JobNames.OIHbl, selectedElement, appContext, showGlobalYesNoDialog, showGlobalOkDialog);
    if(args){
      viewReport(args, "", true);
    }
  }


  function onPopupCompClick(selectedPopupMenuItem: ActionButtonItem) {
    if(selectedPopupMenuItem.label === 'Release Order/Turnover'){
      // if(fmsGlobal.NoRelease){
      //   showGlobalOkDialog('Contact Manager');
      //   return false;
      // }
    }

    return true;
  }
  
  const allowedStatuses = ['', 'E', 'D'];
  const listSec = findSecurityTask(appContext, FmsSecTask.OIHbl);
  
  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
    
  const canBeCopied = hasSelectedRow && !hasOpenedNew() && listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;
  const canBeAdd = !hasOpenedNew() && listSec?.grantAdd;

  //const AccountingButton = jobListContext.infoAreaContent === 'custom' ? HighlightButton : PrimaryButton;

  const openedByF6 = jobListContext.openedByF6 &&
    !!jobListContext.f6Query &&
    jobListContext.f6Origin === '/common/joblistview/mbl/oceanImport';

  const openedByMaster = jobListContext.openedByF6 &&
    !!jobListContext.f6Query &&
    jobListContext.f6Origin === '/oceanImport/mbl/edit/' + jobListContext.f6Query;

  const newUrl = openedByF6 || openedByMaster
    ? `/oceanImport/hbl/add?mblRefId=${jobListContext.f6Query}`
    : '/oceanImport/hbl/add';

  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        <UniqueLinkButton name ='oih-list-add-button' display="primary" size="regular" link={newUrl} uniqueLinkPrefixQuery="/oceanImport/hbl/add" disabled={!canBeAdd} label="New" />&nbsp;
        <PrimaryButton name ='oih-list-view-button' size="regular" disabled={!hasSelectedRow} onClick={view}>View</PrimaryButton>&nbsp;
        <PrimaryButton name ='oih-list-edit-button' size="regular" disabled={!canBeEdit} onClick={edit}>Edit</PrimaryButton>&nbsp;
        <PrimaryButton name ='oih-list-delete-button' size="regular" disabled={!canBeDeleted} onClick={deleteHbl}>Delete</PrimaryButton>&nbsp;
        <PrimaryButton name ='oih-list-copy-button' size="regular" disabled={!canBeCopied} onClick={copy}>Copy</PrimaryButton>
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        <PrimaryButton size="regular" name ='oih-list-viewBillings-button' onClick={viewBillings}>{constants.List_Billings}</PrimaryButton>&nbsp;
        <PrimaryButton size="regular" name='oih-list-deleteHistory-button' onClick={moveToDeleteHistoryReport}>Delete History</PrimaryButton>
      </div>
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent && onPopupCompClick(selectedPopupMenuItem) ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 760}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, {onPopupClose})}
        </IfmsModal>
      ) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.subMenu ? onSubMenuClick(selectedPopupMenuItem.subMenu) : null}
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.link ? onLinkClick(selectedPopupMenuItem.link) : null}
      {jobListContext.recogModalData?.isOpen ? (
        <RecogModal reloadData={doAfterRecog} onCancel={onRecogModalClose} mTbId={selectedElement.oiMblId} mTbName={"T_OIMMAIN"} isSet={jobListContext.recogModalData?.isSet} ></RecogModal>
      ) : null}
    </div>
  );
}

function HblListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function formatData(data:Array<OiHblListItem>) {
  return data.map(d => ({
    ...d,
    //hblType: formatHblType(d.hblType),
    bizMode: formatHblType(d.bizMode),
    hasCLimit: d.hasCLimit === 'Y', // Backend returns Y/N instead of bool
  }));
}

function useHblOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);

  const appContext = useContext(ApplicationContext);
  const systemSettings = useSystemSettings();
  const fmsGlobal = getFmsGlobal();
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  function switchToMblFor(hbl:OiHblListItem|null) {
    if (!hbl) {
      return;
    }

    jobListContext.setFilterForScreenExternally('/common/joblistview/mbl/oceanImport',
      //'mblNo', 'Mbl No', hbl.mblNo ?? '', 'updated', false
      'id', 'Ref. #', hbl.oiMblId, 'update', false, true, null, 'refNo', hbl.refNo, false,true);
    openNewPage(history, `/common/joblistview/mbl/oceanImport`, NavigationType.newPage);
  }

  function switchToContainerFor(hbl:OiHblListItem|null) {
    if (!hbl) {
      return;
    }

    jobListContext.setFilterForScreenExternally('/common/joblistview/OICN/oceanImport', 
      //'refNo', 'Ref No', mbl.refNo ?? '', 'updated', false
      // 'refNo', '', mbl.refNo ?? '', 'update', false);
      'oiMblId', 'Ref. #', hbl.oiMblId, 'update', false, true, null, 'refNo', hbl.refNo, false, true);
    openNewPage(history, `/common/joblistview/OICN/oceanImport`, NavigationType.newPage);
  }


  function switchToAmsFor(hbl:OiHblListItem|null) {
    if (!hbl) {
      return;
    }

    jobListContext.setFilterForScreenExternally('/common/joblistview/AMSH/ams', 
    //'refNo', 'Ref No', mbl.refNo ?? '', 'updated', false
    // 'refNo', '', mbl.refNo ?? '', 'update', false);
    'amsLinkId', 'AMS ID', hbl.amsLinkId, 'update', false, true, null,null,null, false, true);
    openNewPage(history, `/common/joblistview/AMSH/ams`, NavigationType.newPage);
  }

  async function OblColClickFor(fieldName: string, data: any) {
    //fieldName: OblStat, OblDate

    // if (fmsGlobal.NoRelease) {
    //   showGlobalOkDialog('Contact Manager!');
    //   return;
    // }

    let nRet = 0;

    if (data.oblStat === 'N' && fieldName === 'oblStat') {
      switch (fmsGlobal.AcmeID3) {
        case 'OEC':
        case 'CCL':
          // chkOblForm
          break;
        default:
          const confirm = await showGlobalYesNoDialog(
            <div>
              <h3>Original B/L Received ?</h3>
            </div>
          ,false, 0, true);

          if (confirm) {
            nRet = 1;
          } else {
            nRet = 0;
          }
          break;
      }

      if (nRet !== 0) {
        let now = nowDate();
        const apiResult = await appContext.api.setOblCol(data.id, nRet.toString(), now);
        if (apiResult && apiResult.success) {
          data.oblStat = 'Origin';
          data.oblDate = now;
        }
      }
    }

    if (data.oblStat !== 'N') {
      if (data.expRls === true) {
        showGlobalOkDialog('EXPRESS RELEASE');
      } else {
        let tRet = '';
        if (data.oblCol === '1') tRet = ' at Origin';
        else if (data.oblCol === '2') tRet = ' at Dest.';
        if (["OEC", "CCL"].indexOf(fmsGlobal.AcmeID3 ?? '') > -1) tRet = '';

        showGlobalOkDialog(`O B/L RECEIVED ON ${formatDate(data.oblDate, systemSettings.dateFormat ?? '')}${tRet}`);
      }
    }
  }
  
  async function RlsColClickFor(row: any, data:any) {
    // if (fmsGlobal.NoRelease) {
    //   showGlobalOkDialog('Contact Manager!');
    //   return;
    // }

    if (fmsGlobal.CashierRelease && data.rlsStat !== 'y') {
      jobListContext.setRowExtrasId(data.id);
    } else if (data.rlsStat === 'Y') {
      showGlobalOkDialog(`Released on ${formatDate(data.rlsDate, systemSettings.dateFormat ?? '')} by ${data.rlsBy??''}`);
    } else {
      const doRelease = await showGlobalYesNoDialog(
        <div>
          <h3>Do you want to release?</h3>
        </div>,false, 0, true);

      if (doRelease) {
        await appContext.api.releaseNow({hblId: data.id, hblNo: data.hblNo});
      }
      
    }
  }

  async function switchToAcctInfo(hbl:OiHblListItem|null) {
    if (!hbl) {
      return;
    }

    openNewPage(history, `/accounting/Acct/${JobNames.OIHbl}/${hbl.id}`, NavigationType.newPage);
  }


  return { switchToMblFor, switchToContainerFor, switchToAmsFor, OblColClickFor, RlsColClickFor, switchToAcctInfo};
}

function useSelectedHblOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  const { switchToMblFor, switchToContainerFor, switchToAmsFor } = useHblOperations();

  const selectedElement = jobListContext.selectedElement as OiHblListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const channel = postal.channel('ajax');
  const dispatch = useAppDispatch();

  const setSavedEntityOim = useSetEditedId([JobNames.OIMbl]);

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl('/oceanImport/hbl/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const openedByF6 = jobListContext.openedByF6 &&
      !!jobListContext.f6Query &&
      jobListContext.f6Origin === '/common/joblistview/mbl/oceanImport';

    const openedByMaster = jobListContext.openedByF6 &&
      !!jobListContext.f6Query &&
      jobListContext.f6Origin === '/oceanImport/mbl/edit/' + jobListContext.f6Query;

    const newUrl = openedByF6 || openedByMaster
      ? `/oceanImport/hbl/add?mblRefId=${jobListContext.f6Query}`
      : '/oceanImport/hbl/add';

    openNewPage(history, newUrl, NavigationType.newPage);
  }

  async function deleteHbl() {
    if (!selectedElement) {
      return;
    }

    if (
      jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/hbl/edit/${selectedElement.id}`) || 
      jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/hbl/view/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close HBL first', false, null, "warning");
      return;
    }

    if (
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/view/OIHB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/bill/edit/OIHB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/view/OIHB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/invoice/edit/OIHB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/view/OIHB/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenInAnyOperationStartingWithUrl(`/accounting/crdb/edit/OIHB/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Bill/Invoice/CrDb first.', false, null, 'warning');
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Confirm to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.OIHbl, { id:selectedElement.id, pimsLinkId: selectedElement.pimsLinkId });
      
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
        setSavedEntityOim(selectedElement.oiMblId.toString(), false);
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message, false, null, 'warning');
      }
    }
  }

  async function viewBillings() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;

    const viewUrl = `/oceanImport/viewBillings/hbl/${id}`;
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function moveToDeleteHistoryReport() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const viewUrl = `/common/deleteHistory?jobname=${JobNames.OIHbl}&id=${id}`;
    
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function viewProfit(viewEdit:boolean) {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    
    const editUrl = `/oceanImport/hbl/edit/${id}`;
     const viewUrl = `/oceanImport/hbl/view/${id}`;
    //let url = `/oceanImport/hbl/${viewEdit ? 'edit' : 'view'}/${id}`;
    let editUrlProfitTab = `${editUrl}/4`;
    let viewUrlProfitTab = `${viewUrl}/4`;

    if (viewEdit && jobListContext.hasOpenedScreenStartingWithUrlWithoutMe(`/oceanImport/hbl/edit`, editUrl)) {
      await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
      return;
    }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewEdit ? editUrlProfitTab : viewUrlProfitTab, [viewUrl, editUrl]);
  }


  async function edit() {
    if (!selectedElement) {
      return;
    }


    const id = selectedElement.id;
    const editUrl = `/oceanImport/hbl/edit/${id}`;
    const viewUrl = `/oceanImport/hbl/view/${id}`;

    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe('/oceanImport/hbl/edit', editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);

  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/oceanImport/hbl/edit/${id}`;
    const viewUrl = `/oceanImport/hbl/view/${id}`;
    
    const listSec = findSecurityTask(appContext, FmsSecTask.OIHbl);
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl('/oceanImport/hbl/add')) {
      await showGlobalOkDialog(<p>New operation is already in progress.</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/oceanImport/hbl/add?copyId=${id}`, NavigationType.newPage);
  }

  function switchToMbl() {
    const selectedElement = jobListContext.selectedElement as OiHblListItem;
    switchToMblFor(selectedElement);
  }

  function switchToContainer() {
    const selectedElement = jobListContext.selectedElement as OiHblListItem;
    switchToContainerFor(selectedElement);
  }

  function switchToAms() {
    const selectedElement = jobListContext.selectedElement as OiHblListItem;
    switchToAmsFor(selectedElement);
  }

  function recognize(isSet: boolean) {
    jobListContext.setRecogModalData({ isOpen: true, isSet: isSet });
  }

  return { create, deleteHbl, edit, view, copy, 
    switchToMbl, switchToContainer, switchToAms, recognize, 
    viewBillings, moveToDeleteHistoryReport, viewProfit, setSavedEntityOim };
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteHbl, edit, view, copy, switchToMbl, switchToContainer, switchToAms, recognize, viewBillings, viewProfit } = useSelectedHblOperations();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as OiHblListItem;
  const appContext = useContext(ApplicationContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();

  const fmsGlobal = getFmsGlobal();

  function openContainerTracking() {
    window.open(`https://trackinginfo.suntekscm.com/?licid=${fmsGlobal.AcmeID}&hbl=${selectedElement.hblNo}&email=${appContext.user?.email}`);
  }

  function openBLStatus() {
    if (jobListContext.rowExtrasId) {
      return; // Some row is already selected
    }

    jobListContext.setRowExtrasId(selectedElement.id);
  }
  const listSec = findSecurityTask(appContext, FmsSecTask.OIHbl);
 
  async function processFileLock() {
    const fileLockResult = await appContext.api.opClose(JobNames.OIHbl, selectedElement.id, !selectedElement.isClosed);
    if (!!fileLockResult) {
      await showGlobalOkDialog(fileLockResult, false,null,'warning');
      return;
    }

    if (selectedElement.isClosed && jobListContext.hasOpenedScreenStartingWithUrl(`/oceanImport/hbl/edit/${selectedElement.id}`)) {
      const editModelKey = `editOiHbl${selectedElement.id}-/oceanImport/hbl/edit`;
      const keyMatch = _.keys(fastStorage).find(x => x.startsWith(editModelKey));
      if (keyMatch) {
        fastStorage[keyMatch].fileClosed = 0;
        fastStorage[keyMatch].closedBy = '';
        fastStorage[keyMatch].closeDate = null;
      }
    }

    jobListContext.reloadData();
  }
  
  let showFileLock = (!selectedElement?.isClosed ? fmsGlobal.CanFileLock : fmsGlobal.CanFileUnlock);
  const lockCancelRecog = selectedElement?.recognized === 'R' && (selectedElement?.status === 'PC' || selectedElement?.status === 'OC');

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Go to Container List', shortcut: 'F4', separator: false },
    { label: 'Go to AMS List', shortcut: 'Shift+F4', separator: false },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: 'Go to MBL List', shortcut: 'F6', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
    { label: 'Copy', shortcut: 'Ctrl+F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'Bilings', shortcut: 'F7', separator: !listSec?.grantEdit },
    { label: 'Profit', shortcut: 'Ctrl+F7', separator: true, hidden: !listSec?.grantEdit },
    { label: 'HBL Status Update', shortcut: '', separator: false },
    { label: 'CNTR Tracking Info', shortcut: '', separator: false },
    { label: !selectedElement?.isClosed ? 'OP Close' : 'OP Open', shortcut: '', separator: false, hidden: !showFileLock },
    // { label: 'Recog', shortcut: '', separator: false, disabled : selectedElement?.recognized === 'R', hidden: !fmsGlobal.CanFinalize },
    { label: selectedElement?.recognized !== 'R' ? 'Recog' : 'Undo Recog', shortcut: '', separator: false, disabled : lockCancelRecog, hidden: !fmsGlobal.CanFinalize },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="oih-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    disabled: i?.disabled ?? false,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteHbl();
        break;
      case 4:
        switchToContainer();
        break;
      case 5:
        switchToAms();
        break;
      case 6:
        jobListContext.triggerTableSearch('F5');
        break;
      case 7:
        switchToMbl();
        break;
      case 8:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 9:
        copy();
        break;
      case 10:
        viewBillings();
        break;
      case 11:
        viewProfit(listSec?.grantEdit ? true : false);
        break;
      case 12:
        openBLStatus();
        break;
      case 13:
        openContainerTracking();
        break;
      case 14:
        processFileLock();
        break;
      case 15:
        recognize(selectedElement?.recognized !== 'R');
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function HblListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({onFunction: onFunctionKey});

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const listSec = findSecurityTask(appContext, FmsSecTask.OIHbl);

  const { copy, create, edit, view,switchToMbl, switchToContainer, switchToAms, viewBillings, moveToDeleteHistoryReport, viewProfit } = useSelectedHblOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string|null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {
      switchToMbl();
    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "CTRL+F2") {
      if(listSec?.grantAdd)
        copy();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F4") {
      switchToContainer();
    } else if (unprocessedFkey === "SHIFT+F4") {
      switchToAms();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    } else if (unprocessedFkey === "F7") {
      viewBillings();
    } else if (unprocessedFkey === "CTRL+F7") {
      viewProfit(listSec?.grantEdit ? true : false);
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey:string) {
    if (['F6', 'F2', 'CTRL+F2', 'F3', 'F4', 'SHIFT+F4', 'F9', 'F11', 'F8', 'F7', 'CTRL+F7'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  const infoHeadline = `HBL #: ${(jobListContext.selectedElement as OiHblListItem|null)?.hblNo ?? ''}`;

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.OIHbl}
      jobId={(jobListContext.selectedElement as OiHblListItem|null)?.id ?? 0}
      customTabs={[
        {
          headline: 'Billings Info',
          contentLoader: loadInfoAreaInvoiceBillCrDb,
          params: { appContext, jobListContext, history, infoHeadline }
        },
      ]}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
    />
  );
}

/**
 * Concrete implementation for HBL List screen
 *
 * @class HblListView
 * @extends {AbstractListView}
 */
class HblListView extends AbstractListView {
  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    //return this.systemSettings?.showMilestoneInOihList ? oceanImportHblListWithMilestone : oceanImportHblList;
    const tsettings = oceanImportHblList;
    const useTrackingService = suntekSettings?.company?.trackingService ?? false;
    const useBranch = systemSettings?.enableBranch ?? false;
    let cols: XCol.XExportColumn[] = [];
    if (this.systemSettings?.isCanada) {
      cols = OiHblListItem.getExportCollection(OihListType.NormalCan, useTrackingService, useBranch);
    }
    else if (this.systemSettings?.showMilestoneInOihList) {
      cols = OiHblListItem.getExportCollection(OihListType.HblInfo, useTrackingService, useBranch);
    }
    else if (this.suntekSettings?.oceanAir?.useLotNumber){
      cols = OiHblListItem.getExportCollection(OihListType.UseLot, useTrackingService, useBranch);
    }
    else {
      cols = OiHblListItem.getExportCollection(OihListType.Normal, useTrackingService, useBranch);
    }
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type };
    });
    return tsettings;

  }

  getTableDomIdSuffix(): string {
    let result = ''
    if (this.systemSettings?.showMilestoneInOihList)
      result = 'milestone'
    else if (this.systemSettings?.isCanada)
      result = 'canada'
    return result;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'updated',
      orderByAscending: false,
    };
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'recognized',
        renderer: RecognizedFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'shipmentType',
        renderer: ShipmentTypeFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'moveType',
        renderer: MoveTypeFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'bizMode',    //'hblType',
        renderer: HblTypeFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'invStat',    //'inFlag',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'billStat',   //'biFlag',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'crDbStat',   //'crdbFlag',
        renderer: BillInvoiceCrdbFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'hasCLimit',
        renderer: undefined,
        searchValueExtractor: (v:any|null|undefined) => v === true ? 'Y' : 'N',
      },
      {
        accessor: 'trStatus',
        renderer: RQFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      // {
      //   accessor: 'amsBlNo',
      //   renderer: CheckboxFilterRenderer, 
      //   searchValueExtractor: (v: any | null | undefined) => v
      // },
      // {
      //   accessor: 'isfNo',
      //   renderer: CheckboxFilterRenderer, 
      //   searchValueExtractor: (v: any | null | undefined) => v ? 'true' : 'false'
      // },

      // { accessor: 'amsDownload', 
      //   renderer: CheckboxFilterRenderer, 
      //   searchValueExtractor: (v:any|null|undefined) => v ? 'true' : 'false' 
      // },
      // { accessor: 'customsClearance', 
      //   renderer: CheckboxFilterRenderer, 
      //   searchValueExtractor: (v:any|null|undefined) => v ? 'true' : 'false' },
      // { accessor: 'customsHold', 
      //   renderer: CheckboxFilterRenderer, searchValueExtractor: (v:any|null|undefined) => v ? 'true' : 'false' },
      // { accessor: 'examOn', 
      //   renderer: CheckboxFilterRenderer, searchValueExtractor: (v:any|null|undefined) => v ? 'true' : 'false' },
      // { accessor: 'examOff', 
      //   renderer: CheckboxFilterRenderer, searchValueExtractor: (v:any|null|undefined) => v ? 'true' : 'false' },
      // { accessor: 'fdaHold', 
      //   renderer: CheckboxFilterRenderer, searchValueExtractor: (v:any|null|undefined) => v ? 'true' : 'false' },
      // { accessor: 'fdaRelease', 
      //   renderer: CheckboxFilterRenderer, searchValueExtractor: (v:any|null|undefined) => v ? 'true' : 'false' },
      // { accessor: 'releaseOrderRequired', 
      //   renderer: CheckboxFilterRenderer, searchValueExtractor: (v:any|null|undefined) => v ? 'true' : 'false' },
      // { accessor: 'customsRelease', 
      //   renderer: CheckboxFilterRenderer, searchValueExtractor: (v:any|null|undefined) => v ? 'true' : 'false' },
    ];
  }

  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings, listCount: number, useDarkMode: boolean ): ListRowRenderer[] {
    const lType = this.systemSettings?.showMilestoneInOihList ? OihListType.HblInfo : OihListType.Normal
    const useTrackingService = suntekSettings?.company?.trackingService ?? false;
    const useBranch = systemSettings?.enableBranch ?? false;
    
    return OiHblListItem.getExportCollection(lType, useTrackingService, useBranch).map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if (x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      else if (x.dataIndex === "shipmentType") colRenderer.Cell = ShipmentTypeRenderer;
      else if (x.dataIndex === 'recognized') {
        colRenderer.Cell = RecognizedRenderer;
      }
      else if(x.dataIndex === 'invStat' || x.dataIndex === 'billStat' || x.dataIndex === 'crDbStat') colRenderer.Cell = BillingsRenderer;
      else if (x.dataIndex === 'shipperName' || x.dataIndex === 'consigneeName' || x.dataIndex === 'notifyName' || x.dataIndex === 'brokerName')
        colRenderer.Cell = TextAlignLeftWithAddressTooltipRenderer
      else if (x.dataIndex === "oblStat") {
        colRenderer.Cell = OblColRenderer;
      }
      else if (x.dataIndex === "oblDate") {
        colRenderer.Cell = OblDateRenderer;
      }
      else if (x.dataIndex === "rlsStat") {
        colRenderer.Cell = RlsStatRenderer;
      }
      else if (x.dataIndex === "rlsDate") {
        colRenderer.Cell = RlsDateRenderer;
      }
      else if (x.dataIndex === 'lastEvent') colRenderer.Cell = TrackEventNameRenderer;
      else if (x.dataIndex === "useAmsBlNo") colRenderer.Cell = AmsRenderer;
      else if (x.dataIndex === 'useIsfNo') colRenderer.Cell = IsfRenderer;
      else if (x.dataIndex === 'chbRspCode') colRenderer.Cell = ChbRenderer;
      else if (x.dataIndex === 'payStat') colRenderer.Cell = PaidRenderer;
      else if (x.dataIndex === 'itNo') colRenderer.Cell = InbondRenderer;
      else if (x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if (x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if (x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if (x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'pkgs')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} />;
        else if (x.dataIndex === 'cbm')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={3} />;
        else
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
      }
      else if(x.dataIndex === 'trStatus'){
        colRenderer.Cell = (props: any) => <LastEventRenderer {...props} jobName={JobNames.OIHbl} />;
        colRenderer.Header =  () => <div><img style={{float:'left'}} height="16px" src={useDarkMode ? cntrWhite : cntrBlack} alt='' />Container Tracking</div>;
      }
      // debugger
      return colRenderer;
    });

  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    colRenderer.push({accessor: 'oblDate', changedValue: (value: any)=> { return formatDate(value['oblDate'])}});
    colRenderer.push({accessor: 'rlsDate', changedValue: (value: any)=> { return formatDate(value['rlsDate'])}});
    colRenderer.push({accessor: 'lastEvent', changedValue: (value: any)=> { return (!!value['lastEvent'] ? value['lastEvent'] + ' ' + formatDateTime(value['lastEventDate']) : '')}});
    //colRenderer.push({accessor: 'useAmsBlNo', changedValue: (value: any)=> { return value['useAmsBlNo'] ? 'checked' : ''}});
    colRenderer.push({accessor: 'useAmsBlNo', changedValue: (value: any)=> { return nullableCheckBoxValue(value['useAmsBlNo'])}});
    colRenderer.push({accessor: 'useIsfNo', changedValue: (value: any)=> { return nullableCheckBoxValue(value['useIsfNo'])}});
    colRenderer.push({accessor: 'pkgs', changedValue: (value: any)=> { return value['pkgs']}});
    colRenderer.push({accessor: 'cbm', changedValue: (value: any)=> { return Decimalformat(value['cbm'],3)}});
    colRenderer.push({accessor: 'lbs', changedValue: (value: any)=> { return Decimalformat(value['lbs'],2)}});
    colRenderer.push({accessor: 'kgs', changedValue: (value: any)=> { return Decimalformat(value['kgs'],2)}});
    colRenderer.push({accessor: 'doorMove', changedValue: (value: any)=> { return nullableCheckBoxValue(value['doorMove'])}});
    colRenderer.push({accessor: 'cClear', changedValue: (value: any)=> { return nullableCheckBoxValue(value['cClear'])}});
    colRenderer.push({accessor: 'cHold', changedValue: (value: any)=> { return nullableCheckBoxValue(value['cHold'])}});   
    colRenderer.push({accessor: 'trStatus', changedValue: (value: any)=> { 
      let text = '';
      if(value['trType'] === 'C' || value['trType'] === 'M'){
        switch(value['trStatus']){
          case 'Q':
            text = 'Start to Request';
            break;
          case 'failed':
            text = 'Invalid or Error';
            break;
          case 'tracking_stopped':
            text = 'End of Tracking';
            break;
          default:
            text = 'Under Movement';
            break;
        }
      }
      return text;
    }});
    return colRenderer;
  }

  async fetchAndFormatData(api: any, search: Search): Promise<DataFetchResult> {
    //const apiResult = await api.getOceanImportHbl(search);
    const apiResult = await api.getListItems(JobNames.OIHbl, 'OiHblListItem', 
      OiHblListItem.calculateSearchParameters(search, OiHblListItem.MapSearchFields, ['shipmentType']), 
      1, 
      search.pageSize);
    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return { data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  renderCommands(): ReactNode {
    return (
      <HblListCommands />
    );
  }

  renderBeforeConfigureButton(): ReactNode {
    return (
      <HblListToolbar />
    );
  }

  renderAfterConfigureButton(): ReactNode {
    return <></>;
  }

  renderExtras(hideLogHistory: boolean): ReactNode {
    return <HblListViewExtras hideLogHistory={hideLogHistory} />
  }

  public renderInsideTopRightOpMenu(): React.ReactNode {
    return (
      <BlackInverseButton size="large" data-tooltip="Container Tracking" >
        <ContainerTrackingIcon width={20} height={20} />
      </BlackInverseButton>
    );
  }

  getViewUrlFor(row: OiHblListItem) {
    return row && row.id ? `/oceanImport/hbl/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'HBL List';
  };

  renderRowExtras(rowId: number | null, context: IJobListViewContext, cell: any): React.ReactNode|null {
    if (!rowId) {
      return null;
    }

    function onClose() {
      const storageKey = `oi-hbl-milestone-${rowId}`;
      fastStorage[storageKey] = null;
      context.setRowExtrasId(null);
    }

    function getTrackRequestTitle(trStatus: string) {
      return 'Tracking Request' + (!_.isEmpty(trStatus) && trStatus !== 'Q' ? ` - ${trStatus.toUpperCase().replace('_', ' ')}` : '');
    }

    function onCloseTracking49Popup() {
      const storageKey = `oih-trackrequest-${rowId}`;
      fastStorage[storageKey] = null;
      context.setRowExtrasId(null);
      context.setTrackingRequestEmailList(undefined);
    }

    function onCloseHblRlsPopup() {
      const storageKey = `oih-hblrls-${rowId}`;
      fastStorage[storageKey] = null;
      context.setRowExtrasId(null);
    }

    const hblElement = (context.data ?? []).find(x => x.id === rowId);

    if(['rlsStat', 'rlsDate'].indexOf(cell.column.dataIndex) > -1){
      return (
      <IfmsModal isBlueHeader cancelOnEsc draggable isOpen title={'Release H B/L'} onCancel={onCloseHblRlsPopup} width="900px">
        <HblReleasePopup
          hblId={rowId}
          storageKey={`oih-hblrls-${rowId}`}
          onClose={onCloseHblRlsPopup} 
          isView={false}
        />
      </IfmsModal>
      )
    }
    else if (context.trackingRequestEmailList === 'OpenTrackRequestViewMode')
      return (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onCloseTracking49Popup} draggable isOpen title={getTrackRequestTitle(cell.row.original.trStatus)} width="500px">
             <TrackingRequest
               jobId={rowId}
               storageKey={`oih-trackrequest-${rowId}`}
               onClose={onCloseTracking49Popup}
               jobName={JobNames.OIHbl}
               trStatus={cell.row.original.trStatus}
               trType={cell.row.original.trType}
               mode={'view'}
               vcResult={''}
               containerNo={cell.row.original.containerNo}
             />
        </IfmsModal>
      );
    else
      return (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onClose} draggable isOpen title="HBL Status Update" width="760px">
          <HblBlStatusPopup hblNo={hblElement?.hblNo ?? ''} hblId={rowId} storageKey={`oi-hbl-milestone-${rowId}`} onClose={onClose} isView={false} />
        </IfmsModal>
      );
  }

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.OIHbl} keyProp='id' showAdjustBalance={false} showFixJournal={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  commandsAfterMemoLogBtn():React.ReactNode{
    //#1607
    // return <AfterMemoLogButtonCommands />
    return null;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }

  useLogHistory(): boolean {
    return true;
  }
};

export default HblListView;
